import { useQuery } from "@tanstack/react-query"
import axios from "axios";

const fetchPageData =(shelve_id,page)=>{
    const beURL = localStorage.getItem('BeURL'); 
    return axios.get(`${beURL}pages/${shelve_id}/?page=${page}`).then(res => res.data); 
}


export const useShelvePageList=(enabled, shelve_id, page)=>{
    return useQuery({
        queryKey:[`shelvePages-${shelve_id}`],
        queryFn:()=> fetchPageData(shelve_id,page),
        enabled,
        // refetchOnMount:false,
        // refetchOnWindowFocus:false,
    })
} 